/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {FullScreenClicker} from "@nolimitcity/slot-game/bin/core/component/FullScreenClicker";
import {BonusBunniesStickyBonusValueContainer} from "./BonusBunniesStickyBonusValueContainer";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";

export class BonusBunniesStickyBonusWPView extends BaseView {

    private _stickyBonusValues:BonusBunniesStickyBonusValueContainer[][];

    //Used by Harvester and Fertilizer
    private _duplicateValues:PIXI.BitmapText[][];

    //Only used for restore
    private _isRestore:boolean;
    private _restoreStickyBonusPositions:boolean[][];
    private _restoreStickyBonusValues:number[][];
    private _restoreOverlaySymbols:string[][];

    constructor() {
        super();
        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BONUS_SYMBOL_VALUE.name).addChild(this);
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onGameReady());
    }

    private onGameReady():void {
        if(this._isRestore == true) {
            this.setRestoreStickyBonusSyms();
        }
    }

    protected initAnimations():void {
        this._stickyBonusValues = [];
        this._duplicateValues = [];

        for(let i:number = 0; i < 5; i++) {
            const duplicateValuesReel:PIXI.BitmapText[] = [];
            for(let j:number = 0; j < 5; j++) {
                const duplicateValueText:PIXI.BitmapText = new PIXI.BitmapText("", {
                    fontName:BonusBunniesGameConfig.TEXT_STYLES.MULTIPLIER_TEXT_STYLE.font.name!,
                    fontSize:BonusBunniesGameConfig.TEXT_STYLES.MULTIPLIER_TEXT_STYLE.font.size,
                });
                duplicateValueText.visible = false;
                this.addChild(duplicateValueText);
                duplicateValuesReel.push(duplicateValueText);
            }
            this.duplicateValues.push(duplicateValuesReel);
        }

        for(let i:number = 0; i < 5; i++) {
            const reel:BonusBunniesStickyBonusValueContainer[] = [];
            for(let j:number = 0; j < 5; j++) {
                const valueContainer:BonusBunniesStickyBonusValueContainer = new BonusBunniesStickyBonusValueContainer(i, j);
                const valueContainerPosition:PIXI.Point = new PIXI.Point(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
                valueContainer.init();
                valueContainer.anchor.set(0.5, 0);
                valueContainer.position = valueContainerPosition;
                valueContainer.duplicateValueTextPosition = valueContainerPosition;
                valueContainer.alpha = 0;
                this.addChild(valueContainer);
                this.addChild(valueContainer.duplicateValueText);
                reel.push(valueContainer);
            }
            this._stickyBonusValues.push(reel);
        }
    }

    public setSingleStickyBonus(reel:number, row:number, value:number):TimelineLite {
        const showStickyBonusValueTL:TimelineLite = new TimelineLite();
        if(this._stickyBonusValues[reel][row].alpha == 0) {
            let currentReel:number = (reel * 5) + row;
            BonusBunniesGameModuleConfig.bonusBunniesSpinController.disableBonusReel(currentReel);
            const symName:string = Reels.getSymbol(currentReel, 0)!.symName;
            if(symName.indexOf("V") > -1) {
                showStickyBonusValueTL.add(() => this._stickyBonusValues[reel][row].getValueText().scale.set(0.5, 0.5));
                showStickyBonusValueTL.add(() => this._stickyBonusValues[reel][row].valueText = value);
                showStickyBonusValueTL.add([
                    new TweenLite(this._stickyBonusValues[reel][row], 0.1, {
                        alpha : 1,
                        ease : Linear.easeNone
                    }),
                    new TweenLite(this._stickyBonusValues[reel][row].getValueText().scale, 0.2, {
                        x : 1.1,
                        y : 1.1,
                        ease : Linear.easeNone
                    }),
                    new TweenLite(this._stickyBonusValues[reel][row].getValueText().scale, 0.1, {
                        x : 1,
                        y : 1,
                        ease : Linear.easeNone
                    })
                ]);
            } else if(symName == "B2") {
                this._stickyBonusValues[reel][row].valueText = 0;
            } else if(symName.indexOf("B") > -1) {
                this._stickyBonusValues[reel][row].valueText = value;
            }
        }
        showStickyBonusValueTL.add(() => this._stickyBonusValues[reel][row].alpha = 1);
        return showStickyBonusValueTL;
    }

    public setStickyBonus(stickyBonusPositions:boolean[][], stickyBonusValues:number[][], show:boolean = true):void {
        const replaceTL:TimelineLite = new TimelineLite();
        let currentReel:number;
        for(let i:number = 0; i < stickyBonusPositions.length; i++) {
            for(let j:number = 0; j < stickyBonusPositions[i].length; j++) {
                if(stickyBonusPositions[i][j] == true && this._stickyBonusValues[i][j].alpha == 0) {
                    currentReel = (i * 5) + j;
                    BonusBunniesGameModuleConfig.bonusBunniesSpinController.disableBonusReel(currentReel);
                    const symName:string = Reels.getSymbol(currentReel, 0)!.symName;
                    if(symName.indexOf("V") > -1) {
                        this._stickyBonusValues[i][j].valueText = stickyBonusValues[i][j];
                    } else if(symName == "B2") {
                        this._stickyBonusValues[i][j].valueText = 0;
                    } else if(symName.indexOf("B") > -1) {
                        this._stickyBonusValues[i][j].valueText = stickyBonusValues[i][j];
                    }
                    if(show == true) {
                        this._stickyBonusValues[i][j].alpha = 1;
                    }
                }
            }
        }
    }

    public moveValueContainerToTop(valueContainer:BonusBunniesStickyBonusValueContainer):void {
        this.addChild(this._duplicateValues[valueContainer.reel][valueContainer.row]);
    }

    //Used on restore and Bonus Game intro restore
    public setRestoreStickyBonusSyms():void {
        let currentReel:number;
        let symName:string;
        for(let i:number = 0; i < this._restoreStickyBonusPositions.length; i++) {
            for(let j:number = 0; j < this._restoreStickyBonusPositions[i].length; j++) {
                //currentReel = (j * 5) + i;
                currentReel = (i * 5) + j;
                symName = this._restoreOverlaySymbols[i][j];
                if(symName == "B") {
                    symName = "V";
                }
                if(this._restoreStickyBonusPositions[i][j] == true) {
                    this._stickyBonusValues[i][j].valueText = this._restoreStickyBonusValues[i][j];
                    this._stickyBonusValues[i][j].alpha = 1;
                    if(symName.indexOf("V") > -1) {
                        BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.playVSymbolAttention(currentReel, false);
                    } else if(symName.indexOf("B2") > -1) {
                        BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.activateB2Symbol(currentReel);
                    } else if(symName.indexOf("B3") > -1) {
                        BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.activateB3Symbol(currentReel);
                    } else if(symName.indexOf("B4") > -1) {
                        BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.activateB4Symbol(currentReel);
                    }
                } else {
                    Reels.getSymbol(currentReel, 0)!.replaceWith("X", currentReel, BonusBunniesGameConfig.instance.SYMBOL_STATES.normal);
                }
            }
        }
    }

    public setBonusIntroStickyBonusSyms(bonusValuesAfterSpin:number[][]):void {
        let currentReel:number;
        for(let i:number = 0; i < bonusValuesAfterSpin.length; i++) {
            for(let j:number = 0; j < bonusValuesAfterSpin[i].length; j++) {
                currentReel = (i * 5) + j;
                if(bonusValuesAfterSpin[i][j] > 0) {
                    this._stickyBonusValues[i][j].valueText = bonusValuesAfterSpin[i][j];
                    this._stickyBonusValues[i][j].alpha = 1;
                    this._stickyBonusValues[i][j].getValueText().alpha = 0;
                    BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.playVSymbolAttention(currentReel, false);
                    //Reels.getSymbol(currentReel, 0)!.replaceWith("V", currentReel, BonusBunniesGameConfig.instance.SYMBOL_STATES.normal);
                } else {
                    Reels.getSymbol(currentReel, 0)!.replaceWith("X", currentReel, BonusBunniesGameConfig.instance.SYMBOL_STATES.normal);
                }
            }
        }
    }

    public addValueToStickyBonus(reel:number, row:number, value:number):void {
        const numberScaleTL:TimelineLite = new TimelineLite();
        this._stickyBonusValues[reel][row].currentValue += value;
        numberScaleTL.add(() => this._stickyBonusValues[reel][row].valueText = this._stickyBonusValues[reel][row].currentValue);
        numberScaleTL.add(new TweenLite(this._stickyBonusValues[reel][row].getValueText().scale, 0.2, {
            x : 1.5,
            y : 1.5
        }));
        numberScaleTL.add(new TweenLite(this._stickyBonusValues[reel][row].getValueText().scale, 0.2, {
            x : 1,
            y : 1
        }));
    }

    public cleanupStickyBonusValues():void {
        for(let i:number = 0; i < this._stickyBonusValues.length; i++) {
            for(let j:number = 0; j < this._stickyBonusValues[i].length; j++) {
                this._stickyBonusValues[i][j].alpha = 0;
                this._stickyBonusValues[i][j].currentValue = 0;
                this._stickyBonusValues[i][j].reset();
            }
        }
    }

    public getBonusValue(reel:number, row:number):BonusBunniesStickyBonusValueContainer {
        return this._stickyBonusValues[reel][row];
    }

    public getAllActiveBonusValues():BonusBunniesStickyBonusValueContainer[] {
        const activeBonusValues:BonusBunniesStickyBonusValueContainer[] = [];
        for(let i:number = 0; i < this._stickyBonusValues.length; i++) {
            for(let j:number = 0; j < this._stickyBonusValues[i].length; j++) {
                if(this._stickyBonusValues[i][j].alpha == 1) {
                    activeBonusValues.push(this._stickyBonusValues[i][j]);
                }
            }
        }
        return activeBonusValues;
    }

    public activateRestoreMode(bonusOverlaySymbols:string[][], stickyBonusPositions:boolean[][], stickyBonusValues:number[][], autoRestore:boolean):void {
        this._restoreOverlaySymbols = bonusOverlaySymbols;
        this._restoreStickyBonusPositions = stickyBonusPositions;
        this._restoreStickyBonusValues = stickyBonusValues;
        this._isRestore = autoRestore;
    }

    //Sets values on all multiplier symbols on abort
    public abortMultiplierSymbols(stickyBonusValues:number[][]):void{
        for(let i:number = 0; i < stickyBonusValues.length; i++) {
            for(let j:number = 0; j < stickyBonusValues[i].length; j++) {
                if (stickyBonusValues[i][j] > 0){
                    this._stickyBonusValues[i][j].valueText = stickyBonusValues[i][j];
                }
            }
        }
    }

    get duplicateValues():PIXI.BitmapText[][] {
        return this._duplicateValues;
    }

    public abort():void {
        for(let i:number = 0; i < this._duplicateValues.length; i++) {
            for(let j:number = 0; j < this._duplicateValues[i].length; j++) {
                this._duplicateValues[i][j].visible = false;
            }
        }
    }
}